import {
  FormControl,
  InputAdornment,
  OutlinedInput,
  IconButton,
  FormHelperText,
} from "@mui/material";
import React, {useState} from "react";
import style from "../../assets/css/global-fields.module.scss";
import {Visibility, VisibilityOff} from "@mui/icons-material";

const GlobalPassword = ({
  placeH, // Placeholder text (Mandatory)
  type = "password", // Default type is 'password'
  onChange, // Function to handle change event (Mandatory)
  onBlur, // Function to handle blur event (Mandatory)
  value, // Value to bind to the input (Mandatory)
  id, // id of the input (Mandatory)
  inputRef, // Optional: Reference for the input
  label, // Optional: Label for the input
  error, // Optional: Error prop to show if there's a validation error
  helperText, // Optional: Helper text to show error messages
  name, // Optional: Name for the input field (mandatory in Formik)
  fullWidth = true, // Optional: Default to full width
  disabled = false, // Optional: Default to full width
  cssClass,
  showPass = false,
}) => {
  const [showPassword, setShowPassword] = useState(showPass);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div className={style.proposalPassField}>
      <FormControl
        fullWidth={fullWidth}
        error={error}
        className="TextFieldPosiRela"
      >
        {/* {label && (
            <InputLabel htmlFor={id} style={{ color: error ? "#FF2116" : "inherit" }}>
              {label}
            </InputLabel>
          )} */}
        <OutlinedInput
          id={id}
          name={name}
          type={showPassword ? "text" : type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          inputRef={inputRef}
          placeholder={placeH}
          // startAdornment={
          //   <InputAdornment position="start">
          //     <img src={MsgIcon} alt="icon" />
          //   </InputAdornment>
          // }
          disabled={disabled}
          className={cssClass || "  "}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        {error && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </div>
  );
};

export default GlobalPassword;
